import { useMemo } from 'react';
import useRootSelector from 'common/hooks/useRootSelector';

import {
  selectCurrentUserCorporation,
  selectUserSelectedOrganization,
} from 'modules/authentication/state/selectors';

import { INamedEntityImt } from 'common/interfaces/common';
import { IUserOrganizationImt } from 'common/interfaces/clients';
import { BookingPaths } from 'modules/booking/constants';
import { selectLeadId } from 'modules/crm/state/leads/selectors';

export const useTopics = (): string[] => {
  const corporation: INamedEntityImt = useRootSelector(selectCurrentUserCorporation);
  const selectedOrg: IUserOrganizationImt = useRootSelector(selectUserSelectedOrganization);
  const leadId = useRootSelector(selectLeadId);

  return useMemo(() => {
    const corporationId = corporation?.get('id');

    const topics = [
      `/topic/corporations/${corporationId}/check-ins`,
      `/topic/corporations/${corporationId}/invoices`,
      `/topic/corporations/${corporationId}/inventories`,
      `/topic/corporations/${corporationId}/notifications`,
    ];

    if (window.location.pathname === BookingPaths.BookingEvents) {
      topics.push(`/topic/events/clubs/${selectedOrg?.get('id')}`);
    }

    if (leadId) {
      topics.push(`/topic/employees/${leadId}/emails`);
    }

    return topics;
  }, [corporation, selectedOrg, leadId]);
};
